<template>
  <div class="d-inline-block">
    <feature id="debug_sort_order">
      [{{sortable.sort_order}}]
    </feature>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    sortable: Object,
  },
})
</script>